import { useState, useEffect, useRef } from "react";
import { Box, Grid, Typography, Paper, Alert, Snackbar } from "@mui/material";
import { Info, PropaneSharp } from "@mui/icons-material";
import { UrlApi } from "../../../../services/apirest";
import { getData } from "../../../../services/library";
import CabeceraEditar from "./CabeceraEditar";
import CuerpoEditar from "./CuerpoEditar";
import ImpuestosEditar from "./ImpuestosEditar";
import ResumenEdicion from "./ResumenEdicion";
import { armarNroComprobante } from "../functions";

function TituloSeccion({ children }) {
    return (
        <Box sx={{ borderBottom: 1, borderColor: "divider", mt: 0.5 }}>
            <Typography
                variant="subtitle2"
                sx={{
                    color: "#1f618d",
                    fontWeight: "bold",
                    textAlign: "center",
                    py: 0.5,
                }}
            >
                {children}
            </Typography>
        </Box>
    );
}

export default function FormComprobanteEditar(props) {
    const [modal, setModal] = useState(false);
    const iconInfo = <Info sx={{ fontSize: 40 }} />;
    const timeoutRef = useRef(null);
    const [inputValue, setInputValue] = useState("");
    const [alert, setAlert] = useState();

    // const almacenarCabecera = (e) => {
    //     const { name, value } = e.target;
    //     let valorFormateado = value;

    //     // Si es punto de venta, completamos con ceros hasta 4
    //     if (name === "comprobante_pv") {
    //         valorFormateado = value.padStart(4, "0");
    //     }
    //     // Si es el número, completamos hasta 8
    //     if (name === "comprobante_nro") {
    //         valorFormateado = value.padStart(8, "0");
    //     }

    //     props.setDatos(prev => {
    //         const nuevosDatos = { ...prev, [name]: valorFormateado };

    //         // RECONSTRUCCIÓN: Unimos PV y NRO para mantener 'nro_comprobante' actualizado
    //         nuevosDatos.nro_comprobante = `${nuevosDatos.comprobante_pv || "0000"}-${nuevosDatos.comprobante_nro || "00000000"}`;

    //         return nuevosDatos;
    //     });
    // };

    const almacenarCabecera = (e) => {
        const { name, value } = e.target;

        const valorLimpio = (name === "comprobante_pv" || name === "comprobante_nro")
            ? value.replace(/\D/g, "")
            : value;

        props.setDatos(prev => {
            const nuevosDatos = { ...prev, [name]: valorLimpio };

            nuevosDatos.nro_comprobante = armarNroComprobante(
                props.comprobanteSelected,
                nuevosDatos
            );

            return nuevosDatos;
        });
    };

    const handleOnChangeProvSel = async (e, proveedor) => {
        // 1. Manejo del caso cuando limpian el Autocomplete
        if (!proveedor) {
            props.setproveedorSelected(null); // Antes era props.propiedades.setProveedorSelected
            props.setDatos(prev => ({ ...prev, id_proveedor: null, id_condicionpago: "" }));
            props.setImputaciones([]);
            return;
        }

        // 2. Actualizamos datos básicos
        props.setDatos((prev) => ({
            ...prev,
            id_condicionpago: proveedor?.id_condicionpago || "",
            id_proveedor: proveedor.padron === 1 ? null : proveedor.id
        }));

        props.setproveedorSelected(proveedor);

        // 3. Lógica de Imputaciones
        if (proveedor.padron === 0) {
            try {
                const rest = await fetch(`${UrlApi}/imputacion_proveedores/xid/${proveedor.id}`);
                const json = await rest.json();

                if (!json || json.length === 0) {
                    getData("/imputacion_gastos", (data) => {
                        props.setImputaciones(data);
                        props.setGuardarImputacProveedor(true);
                    });
                    setAlert(true);
                } else {
                    props.setGuardarImputacProveedor(false);
                    props.setimputacionProveedor(json);
                    getData("/imputacion_gastos", props.setImputaciones);
                }
            } catch (error) {
                console.error("Error buscando imputaciones:", error);
            }
        } else {
            setAlert(true);
            getData("/imputacion_gastos", props.setImputaciones);
            props.setGuardarImputacProveedor(false);
        }
    };

    const percepciones = Array.isArray(props.datosImpuestos) ? props.datosImpuestos : [];
    const tienePercepciones = percepciones.some((item) => {
        const importe = item?.importe;
        const tieneImporte = importe != null && importe !== "" && importe !== 0 && importe !== "0" && importe !== "0,00";
        return !!item?.id_impuesto || tieneImporte;
    });

    return (
        <div>
            <Paper elevation={3}
                sx={{
                    background: "linear-gradient(to right, #f8f9fa, #e8f0fe)",
                    mt: 1,
                    p: 2,
                    borderRadius: 4,
                    borderLeft: "6px solid #1f618d",
                }}>
                <CabeceraEditar
                    propiedades={props}
                    alert={alert}
                    inputValue={inputValue}
                    setInputValue={setInputValue}
                    handleOnChangeProvSel={handleOnChangeProvSel}
                    timeoutRef={timeoutRef}
                    almacenarCabecera={almacenarCabecera}
                    modal={modal}
                    setModal={setModal}
                />
            </Paper>
            <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="top"
            >
                <Grid item xs={8.6}>
                    <TituloSeccion>Detalle</TituloSeccion>
                    <CuerpoEditar propiedades={props} />
                    {tienePercepciones && (
                        <>
                            <TituloSeccion>Percepciones/Otros tributos</TituloSeccion>
                            <ImpuestosEditar propiedades={props} />
                        </>
                    )}
                </Grid>
                <Grid item xs={3.3}>
                    <ResumenEdicion
                        propiedades={props}
                    />
                </Grid>
            </Grid>
        </div>
    )

}